import React, { useContext, useEffect, useRef, useState } from "react";

import ReactECharts from "echarts-for-react";
import apiClient from "../../ApiClient";
import { AppSettings } from "../../config/app-settings";
import DynamicCard from "../../components/DynamicCard";

const requiredParams = [
  "AK PARTİ",
  "CHP",
  "MHP",
  "DEM PARTI",
  "İYİ PARTİ",
  "TİP",
  "YRP",
];

const requiredParamsColors = [
  { parametre: "AK PARTİ", color: "#f7981a" },
  { parametre: "MHP", color: "#2dcc33" },
  { parametre: "DEM PARTI", color: "#660099" },
  { parametre: "İYİ PARTİ", color: "#ffeb3b" },
  { parametre: "TİP", color: "#8B0000" },
  { parametre: "YRP", color: "#964B00" },
  { parametre: "CHP", color: "#ed1b25" },
];

export default function IlceGeneliPartilerinOyDegisimi({
  title,
  city,
  district,
  type,
  filter,
}) {
  const context = useContext(AppSettings);

  const chartRef = useRef();

  const [winner, setWinner] = useState(null);
  const [chartOption, myChartOption] = useState(null);

  const [data] = useState([["Income", "Country", "Year"]]);
  const [chartData, setChartData] = useState(null);

  async function fetchData() {
    myChartOption(null);

    try {
      const response = await apiClient.customPost(
        `/query/preview`,
        {
          chart: 1,
          page_id: 23,
          title: type || "stratejimerkezi-secim-ilce",
          type: type || "stratejimerkezi-secim-ilce",
          description: "",
          customer: null,
          status: true,
          order: 1,
          connection_type: "local",
          sql: {
            column: [
              {
                key: "TARIH",
                value: "select",
              },
              {
                key: "ALT-KATEGORI-2",
                value: "select",
              },
              {
                key: "PARAMETRE",
                value: "select",
              },
              {
                key: "DEGER",
                value: "sum",
              },
            ],
            condition: [
              city
                ? {
                    key: "SEHIR",
                    value: context.removeTurkishCharacters(city).toUpperCase(),
                    operator: "=",
                    type: "and",
                  }
                : null,
              district
                ? {
                    key: "ILCE",
                    value: context
                      .removeTurkishCharacters(district)
                      .toUpperCase(),
                    operator: "=",
                    type: "and",
                  }
                : null,
              filter || null,
            ].filter((item) => item !== null),
            group: [],
          },
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      if (response && response.length !== 0) {
        // 1. Veriyi requiredParams içinde olan parametrelere göre filtrele
        let filteredData = response.filter((item) =>
          requiredParams.includes(item.parametre)
        );

        const groupedData = {};
        filteredData.forEach((item) => {
          const key = item[filter ? "tarih" : "alt-kategori-2"];
          if (!groupedData[key]) groupedData[key] = {};
          groupedData[key][item.parametre] = item;
        });

        // 3. Eksik parametreleri ekle
        Object.keys(groupedData).forEach((category) => {
          requiredParams.forEach((param) => {
            if (!groupedData[category][param]) {
              groupedData[category][param] = {
                tarih: "",
                [filter ? "tarih" : "alt-kategori-2"]: category,
                parametre: param,
                deger_sum: 0,
              };
            }
          });
        });

        // 4. Objeyi düz listeye çevirip tarihe göre sırala
        const sortedData = Object.values(groupedData)
          .flatMap((category) => Object.values(category))
          .sort((a, b) => {
            const yearA = a.tarih ? parseInt(a.tarih.split("-")[0]) : 0;
            const yearB = b.tarih ? parseInt(b.tarih.split("-")[0]) : 0;
            return yearA - yearB;
          });

        // 5. Formatlama
        const formattedData = [
          ["Income", "Country", "Year"],
          ...sortedData.map((item) => [
            item.deger_sum,
            item.parametre,
            item[filter ? "tarih" : "alt-kategori-2"],
          ]),
        ];

        // Winner
        const maxTarih = filteredData.reduce(
          (max, item) => (item.tarih > max ? item.tarih : max),
          filteredData[0].tarih
        );

        const maxItem = !type
          ? filteredData
              .filter(
                (item) =>
                  item.tarih === maxTarih &&
                  !filter &&
                  item["alt-kategori-2"] ===
                    "2024 BELEDİYE BAŞKANLIĞI YEREL SEÇİMLERİ"
              )
              .reduce((max, item) =>
                item.deger_sum > max.deger_sum ? item : max
              )
          : null;

        const parametre = !type ? maxItem.parametre : null;

        setWinner(parametre);
        setChartData(formattedData);
      } else {
        myChartOption("none");
      }
    } catch (error) {
      console.error("Genel Data Error", error);
      myChartOption("none");
    }
  }

  useEffect(() => {
    if (city && district) {
      fetchData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [city, district]);

  // Chart
  useEffect(() => {
    if (data && chartData) {
      run(chartData);

      function run(_rawData) {
        const countries = requiredParams;
        const datasetWithFilters = [];
        const seriesList = [];

        countries.forEach((country) => {
          var datasetId = "dataset_" + country;

          datasetWithFilters.push({
            id: datasetId,
            fromDatasetId: "dataset_raw",
            transform: {
              type: "filter",
              config: {
                and: [
                  // { dimension: "Year", gte: 1950 },
                  { dimension: "Country", "=": country },
                ],
              },
            },
          });

          seriesList.push({
            type: "line",
            datasetId: datasetId,
            showSymbol: false,
            name: country,
            endLabel: {
              show: true,
              formatter: function (params) {
                return (
                  params.value[1] +
                  ": " +
                  params.value[0].toLocaleString("tr-TR")
                );
              },
            },
            labelLayout: {
              moveOverlap: "shiftY",
            },
            emphasis: {
              focus: "series",
            },
            encode: {
              x: "Year",
              y: "Income",
              label: ["Country", "Income"],
              itemName: "Year",
              tooltip: ["Income"],
            },
            itemStyle: {
              color: requiredParamsColors.find(
                (item) => item.parametre === country
              ).color,
            },
          });
        });

        const option = {
          darkMode: window.location.host.includes("datakokpit") ? false : true,
          animationDuration: 1000,
          dataset: [
            {
              id: "dataset_raw",
              source: _rawData,
            },
            ...datasetWithFilters,
          ],
          tooltip: {
            order: "valueDesc",
            trigger: "axis",
          },
          xAxis: {
            type: "category",
            nameLocation: "middle",
            axisLabel: {
              rotate: 45,
              textStyle: {
                color: "#fff",
                fontSize: 10,
              },
              formatter: function (value, index) {
                return value.substring(0, 7) + "...";
              },
            },
          },
          yAxis: {
            axisLabel: {
              color: "#fff",
            },
          },
          grid: {
            right: 80,
            top: 20,
            left: 50,
            bottom: 50,
          },
          series: seriesList,
        };

        myChartOption(option);
      }
    }
  }, [data, chartData]);

  return (
    <div className="position-relative">
      {chartOption && winner && (
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            pointerEvents: "none",
            opacity: 0.4,
            background: requiredParamsColors.find(
              (item) => item.parametre === winner
            ).color,
          }}
        ></div>
      )}
      <DynamicCard
        item={{
          title: title,
        }}
        fullScreen={true}
        events={false}
        chart={
          chartOption ? (
            chartOption === "none" ? (
              <span className="d-block text-center">
                {context?.t?.no_data_available}
              </span>
            ) : (
              <ReactECharts
                option={chartOption}
                ref={chartRef}
                className="w-100 h-100"
              />
            )
          ) : (
            <div className="spinner-border text-theme"></div>
          )
        }
      />
    </div>
  );
}
